export const PYQ = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.57254 16.1412C12.5174 16.1412 15.7154 12.9432 15.7154 8.99833C15.7154 5.05343 12.5174 1.85547 8.57254 1.85547C4.62765 1.85547 1.42969 5.05343 1.42969 8.99833C1.42969 12.9432 4.62765 16.1412 8.57254 16.1412Z"
      stroke="#A8B1B4"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0723 2.92773V8.99916"
      stroke="#A8B1B4"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.94141 2.79688L10.9922 7.84763"
      stroke="#A8B1B4"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 6.49805H8.57143"
      stroke="#A8B1B4"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.27148 6.72656L2.2207 11.7773"
      stroke="#A8B1B4"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.07227 9.35547V15.4269"
      stroke="#A8B1B4"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.29688 10.2969L11.3477 15.3476"
      stroke="#A8B1B4"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.57227 11.498H15.0008"
      stroke="#A8B1B4"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.1289 6.36914L10.0781 11.4199"
      stroke="#A8B1B4"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.57227 11.498C9.95298 11.498 11.0723 10.3788 11.0723 8.99805C11.0723 7.61733 9.95298 6.49805 8.57227 6.49805C7.19155 6.49805 6.07227 7.61733 6.07227 8.99805C6.07227 10.3788 7.19155 11.498 8.57227 11.498Z"
      fill="#13161B"
      stroke="#A8B1B4"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
